import { IChangesObject, isDefined } from 'angular';

export function hasChange(obj: IChangesObject): boolean {
  return isDefined(obj) && isDefined(obj.currentValue) && JSON.stringify(obj.previousValue) !== JSON.stringify(obj.currentValue);
}

export function everyHasChange(objs: { [property: string]: IChangesObject }, ...properties: string[]): boolean {
  return properties
    .map(p => objs[p])
    .filter(obj => isDefined(obj))
    .every(obj => hasChange(obj));
}

export function someHasChange(objs: { [property: string]: IChangesObject }, ...properties: string[]): boolean {
  return properties
    .map(p => objs[p])
    .filter(obj => isDefined(obj))
    .some(obj => hasChange(obj));
}

export function isEmptyObject(obj: any): boolean {
  for (let key in obj) {
    if (obj.hasOwnProperty(key)) {
      return false;
    }
  }
  return true;
}

export function isEmpty(str: string): boolean {
  return !str || str === '';
}

export function isFn(obj: unknown): obj is Function {
  return typeof obj === 'function';
}

/**
 * Copy deeply a object
 */
export function deepCopy<T>(obj: T): T {
  return obj && JSON.parse(JSON.stringify(obj));
}
